import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWallet5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"wallet-5"} maskId="square-filled-radius-0-stroke-1-IconWallet5"><path d="M22 4V9H15V15H22V20H2V4H22Z" fill="currentColor"/><path d="M16 10H23V14H16V10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconWallet5;
